import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { submitUsernameForPasswordRecovery } from '../../core/state/password-management/password-management.actions';
import {
  ActablProductNames,
  Products,
} from '../../core/models/user-profile.model';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { MatIconButton, MatButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: [
    'forgot-password.component.scss',
    '../login-form/login-form.component.scss',
  ],
  imports: [
    MatCard,
    MatCardContent,
    RouterLink,
    MatIcon,
    MatDivider,
    MatIconButton,
    FormsModule,
    MatFormField,
    MatInput,
    MatButton,
    TranslateModule,
  ],
})
export class ForgotPasswordComponent implements OnInit {
  username: string;
  returnPage: string;
  isSuccess: boolean;
  hasError: boolean;

  private route = inject(ActivatedRoute);
  private store = inject(Store);

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.returnPage = params['mode'] ? params['mode'] : 'login';
      this.isSuccess = params['success'];
      this.hasError = params['error'];
    });
  }

  hideAlert() {
    this.hasError = false;
  }

  onSubmit() {
    this.store.dispatch(
      submitUsernameForPasswordRecovery({ username: this.username }),
    );
  }

  protected readonly Products = Products;
  protected readonly ActablProductNames = ActablProductNames;
}
